import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class TermsConditionsService {

  constructor(private http: HttpClient, private serviceCallUtilsService: ServiceCallUtilsService) { }
    /**
   * Description: Método que llama el servicio web que obtiene los terminos y condiciones
   * Autor: Steven Sterling
   * @param category indica la sección desde la cual se llama el componente
   * @return Listado de terminos y condiciones
   */
  getTermsCondList(category){
    if(category.category){
      return this.serviceCallUtilsService.callPostWebService(constants.ENDPINT_TERMS_CONDITIONS, category); 
    } else {
      return this.serviceCallUtilsService.callPostWebService(constants.ENDPINT_TERMS_WITHOUT_CATEGORY, {}); 
    }
  }
}
